import { media, styled, typography } from '@pulse-web-ui/theme';

export const SelectContainer = styled.div`
  ${media.desktop} {
    display: grid;
    grid-template-columns: 230px 230px;
    column-gap: 24px;
    align-items: center;
  }
`;

export const YearHint = styled.span`
  ${typography.regular14}
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 20px;

  ${media.desktop} {
    max-width: 230px;
  }
`;
